export enum TaskCategories {
  APROBACION = 1,
  AMPLIACION = 2,
  RENOVACION = 3,
  ACTUALIZACION_DE_ANTECEDENTES = 4,
  DELEGACION = 5,
}
